import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { StatsCounter } from '@core/stats-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<StatsCounter>()('DashboardStatsCounter');

export {
  actions as DashboardStatsCounterActions,
  selectors as DashboardStatsCounterSelectors,
  reducer as DashboardStatsCounterReducer,
  namespace as DashboardStatsCounterNamespace,
};
